const capitalizeFirstLetter = (string: string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const getArticle = (word: string) => {
  if (!word || typeof word !== 'string') return 'a';

  const firstLetter = word.trim()[0].toLowerCase();

  const vowels = ['a', 'e', 'i', 'o', 'u'];
  return vowels.includes(firstLetter) ? 'an' : 'a';
};

export { capitalizeFirstLetter, getArticle };
